'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Trigger = require('./Trigger');

var _Trigger2 = _interopRequireDefault(_Trigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _Trigger2['default']; // based on rc-trigger 2.6.2


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/lib/vc-trigger/index.js
// module id = jHRN
// module chunks = 0